import React, {Component} from 'react';
import { isEmpty } from "lodash";
import PropTypes, { string } from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { AppBar } from '@material-ui/core';

export function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`,
	};
}

class SwipeableTabs extends Component {
    state = {
        tab: "",
        index: 0
	}
	componentDidMount = () => {
		if( !isEmpty(this.props.default) ){
			this.setState({
				tab: this.props.default,
				index: this.props.labels.indexOf(this.props.default)
			})
		}
	}
    handleChange = (e, tab) => {
		console.log('====================================');
		console.log({e, tab});
		console.log('====================================');
        this.setState({
			tab,
			index: this.props.labels.indexOf(tab)
		})
		if( this.props.getLabel){
			this.props.getLabel(tab)
		}
    };
		
    // handleChangeIndex = (index) => {
    //     this.setState({
    //         index
    //     })
    // };

    render() {
		let { tab, index } = this.state;
		const { children, labels } = this.props;
		console.log("[DEBUG],Labels,",this.props.labels, " and ",tab)
		if (tab === "" && !isEmpty(this.props.default)){
			tab = this.props.default
		}
		return (
			<Box>
				{/* <AppBar position="static" color="secondary"> */}
					<Tabs
						value={tab}
						onChange={this.handleChange}
						// indicatorColor={"primary"}
						indicatorColor={this.props.color || "primary"}
						textColor={this.props.color || "primary"}
						scrollButtons="auto"
						variant="fullWidth"
						// variant="scrollable"
					>
						{labels.map( (label, i) => (
							<Tab label={label} {...a11yProps(i)} key={label} value={label} />
						))}
					</Tabs>
				{/* </AppBar> */}
				<Box p={1}>
					{children[index] || children}
				</Box>
			</Box>
				
			
        );
    }
}

export default SwipeableTabs;
